/* eslint-disable eqeqeq */
import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import TickIcon from "../../../Common/Svgs/TickIcon";
import { updateBatteries } from "../../../Redux/Slices/batteries.slice";
import { updateHome } from "../../../Redux/Slices/home.slice";

// request_type: 1 = HUB, 2 = TRIP, 3 = RENTAL
const BATTERY_REQUEST_TYPE_HUB = 1;
const BATTERY_REQUEST_TYPE_TRIP = 2;

const ItemBody5 = ({ notification }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const requestType = notification?.metaData?.requestType;
  const supplierHubName = notification?.metaData?.supplierHubName;
  const batteryCount = notification?.metaData?.batteryCount;
  const tripId = notification?.metaData?.tripId;

  const getMessage = () => {
    if (requestType === BATTERY_REQUEST_TYPE_TRIP) {
      return (
        <p className="font-poppins text-xs font-light text-black">
          <span className="font-medium text-primary capitalize">
            {supplierHubName}{" "}
          </span>
          has <span className="font-medium text-primary">accepted</span> your
          trip battery request of {batteryCount} batteries for{" "}
          <span className="font-medium"> Trip {tripId}</span>
        </p>
      );
    }

    if (requestType === BATTERY_REQUEST_TYPE_HUB || !requestType) {
      // HUB or legacy notifications without requestType — show assign agent CTA
      return (
        <p className="font-poppins text-xs font-light text-black">
          <span className="font-medium text-primary capitalize">
            {supplierHubName}{" "}
          </span>
          has <span className="font-medium text-primary">accepted </span>
          your request of {batteryCount} batteries. Please assign an agent from
          your hub to collect the batteries.
        </p>
      );
    }

    // RENTAL
    return (
      <p className="font-poppins text-xs font-light text-black">
        <span className="font-medium text-primary capitalize">
          {supplierHubName}{" "}
        </span>
        has <span className="font-medium text-primary">accepted</span> your
        rental battery request of {batteryCount} batteries. The driver will
        collect the batteries directly.
      </p>
    );
  };

  const handleAssign = () => {
    if (!notification?.metaData?.requestId) {
      return;
    }
    dispatch(updateHome({ key: "notificationPopupVisible", value: false }));

    dispatch(
      updateBatteries({
        key: "assignPickupAgentModal",
        value: {
          visible: true,
          data: {
            hubId: notification?.metaData?.receiverHubId,
            hubName: notification?.metaData?.receiverHubName,
            receiverHubId: notification?.metaData?.receiverHubId,
            receiverHubName: notification?.metaData?.receiverHubName,
            requestId: notification?.metaData?.requestId,
            supplierHubName: notification?.metaData?.supplierHubName,
            batteryCount: notification?.metaData?.batteryCount,
          },
        },
      }),
    );

    navigate("/batteries");
  };

  const isHub = requestType === BATTERY_REQUEST_TYPE_HUB || !requestType;
  const showActionButton = notification?.metaData?.action != 1 && isHub;

  return (
    <div>
      {getMessage()}

      {showActionButton && (
        <div className="mt-2 w-full flex items-center">
          <button
            type="button"
            className="flex flex-1 items-center justify-center gap-x-2 bg-primary hover:bg-primary-50 py-2 px-4 rounded-md"
            onClick={handleAssign}
          >
            <TickIcon size={16} className="text-white" />

            <p className="font-poppins text-xs font-medium text-background-white">
              Assign Pickup Agent
            </p>
          </button>
        </div>
      )}
    </div>
  );
};

export default ItemBody5;
